import { useMemo, useState } from "react";
import { articles, channels } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";

const TABS = [{ slug: "all", name: "全部" }, ...channels.map((c) => ({ slug: c.slug, name: c.name }))];

export default function DispatchGrid() {
  const [active, setActive] = useState("all");
  const [expanded, setExpanded] = useState(false);

  const filtered = useMemo(
    () => (active === "all" ? articles : articles.filter((a) => a.channel === active)),
    [active]
  );

  const visible = expanded ? filtered : filtered.slice(0, 6);

  return (
    <section id="latest" aria-label="最新瓜情" className="w-full bg-background-100/70 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
          <div>
            <p className="text-xs font-label text-primary-600 tracking-widest mb-2">LATEST DISPATCH</p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              最新瓜情速递
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
              按频道筛选你关心的方向，突发与插播会随到随更，深度内容会在核对后上线。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {TABS.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                onClick={() => {
                  setActive(tab.slug);
                  setExpanded(false);
                }}
                className={`px-4 py-2 rounded-full text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
                  active === tab.slug
                    ? "bg-foreground-900 text-background-50"
                    : "bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300"
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {visible.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {visible.map((article) => (
              <NewsCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <p className="py-16 text-center text-sm text-foreground-500">
            该频道暂时没有新的瓜情，稍后再来看看。
          </p>
        )}

        {filtered.length > 6 && (
          <div className="mt-10 flex justify-center">
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-sm font-label text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {expanded ? "收起" : `展开全部 ${filtered.length} 条`}
              <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}